import type { MarketVariants } from '@/lib/i18n'

export type Slide8bFraudCallCopy = {
  callerName: string
  callerSubtitle: string
  incomingLabel: string
  declineLabel: string
  acceptLabel: string

  transcript1: string
  /** Line 2, contains the fake currency amount. Currency goes in `fakeAmount`. */
  transcript2Before: string
  fakeAmount: string
  transcript2After: string
  transcript3: string
  /** Small "Live" tag beside the first transcript line. */
  liveLabel: string

  emailFrom: string
  emailSubject: string
  emailPreview: string
  /** Timestamp on the email notification ("now"). */
  nowLabel: string

  whatTheyWantLabel: string
  whatTheyWant: string
  saferMoveLabel: string
  saferMove: string
  verifyRoute1: string
  verifyRoute2: string
  warning: string
}

export const copy: MarketVariants<Slide8bFraudCallCopy> = {
  US: {
    callerName: 'Your Bank',
    callerSubtitle: 'Fraud Prevention Team',
    incomingLabel: 'incoming call',
    declineLabel: 'Decline',
    acceptLabel: 'Accept',

    transcript1:
      'Hello, this is the fraud prevention team at your bank.',
    transcript2Before: "We've flagged two transactions on your account totalling ",
    fakeAmount: '$2,400',
    transcript2After: '.',
    transcript3:
      "I'm sending you a case reference email now so you can see this is genuine.",
    liveLabel: 'Live',

    emailFrom: 'Your Bank',
    emailSubject: 'Fraud Case Opened',
    emailPreview: 'Case FC-90281 opened. Assigned analyst: D. Chen, ext 4492.',
    nowLabel: 'now',

    whatTheyWantLabel: 'What they want:',
    whatTheyWant:
      'You to stay on the line in a state of panic, and trust the email as proof the call is real.',
    saferMoveLabel: 'The safer move:',
    saferMove:
      'Hang up. Take a breath. If there really is fraud, the bank will still know about it when you verify it yourself.',
    verifyRoute1: 'Hang up and call the number on the back of your bank card',
    verifyRoute2:
      'Hang up and log into your banking app to check for real alerts',
    warning:
      'When someone calls you, nothing they send during the call should be trusted. If you think it might be real, hang up and check through a channel you already trust.',
  },
  GB: {
    fakeAmount: '£2,400',
  },
  // CA, AU inherit US "$2,400", both use $ prefix.
  QA: {
    fakeAmount: 'QAR 8,700',
    emailPreview: 'Case FC-90281 opened. Assigned analyst: K. Ahmed, ext 4492.',
  },
  ar: {
    callerName: 'بنكك',
    callerSubtitle: 'فريق مكافحة الاحتيال',
    incomingLabel: 'مكالمة واردة',
    declineLabel: 'رفض',
    acceptLabel: 'قبول',

    transcript1:
      'مرحباً، معك فريق مكافحة الاحتيال في بنكك.',
    transcript2Before: 'رصدنا عمليتين مشبوهتين على حسابك بقيمة إجمالية ',
    fakeAmount: '8,700 ريال قطري',
    transcript2After: '.',
    transcript3:
      'سأرسل إليك الآن بريداً إلكترونياً برقم مرجع الحالة لتتأكد أن هذا الاتصال حقيقي.',
    liveLabel: 'مباشر',

    emailFrom: 'بنكك',
    emailSubject: 'تم فتح حالة احتيال',
    emailPreview: 'تم فتح الحالة FC-90281. المحلل المكلّف: خ. أحمد، تحويلة 4492.',
    nowLabel: 'الآن',

    whatTheyWantLabel: 'ما يريدونه:',
    whatTheyWant:
      'أن تبقى على الخط في حالة من الذعر، وأن تثق بالبريد الإلكتروني كدليل على أن المكالمة حقيقية.',
    saferMoveLabel: 'الخيار الأكثر أماناً:',
    saferMove:
      'أغلق الخط. خذ نفساً. إن كان هناك احتيال فعلاً، فسيظل البنك على علم به عندما تتحقق بنفسك.',
    verifyRoute1: 'أغلق الخط واتصل بالرقم المطبوع على ظهر بطاقتك المصرفية',
    verifyRoute2:
      'أغلق الخط وسجّل الدخول إلى تطبيق البنك للتحقق من وجود تنبيهات حقيقية',
    warning:
      'عندما يتصل بك أحدهم، لا تثق بأي شيء يرسله إليك أثناء المكالمة. إن ظننت أن الأمر قد يكون حقيقياً، فأغلق الخط وتحقّق عبر قناة تثق بها مسبقاً.',
  },
}
